import React from "react";
import { Card, InlineGrid, InlineStack, BlockStack, Text, Link, Icon } from "@shopify/polaris";
import { ClockMajor, DiscountsMajor, StatusActiveMajor } from "@shopify/polaris-icons";

/**
 * Active, scheduled and ended campaign counts, each linking to the Campaigns page.
 * Counts show "-" until the statistics have loaded.
 */
const CampaignOverview = ({ statistics }) => (
  <Card>
    <InlineGrid columns={3} gap="400">
      <Stat icon={DiscountsMajor} count={statistics?.ActiveCount} label="active" />
      <Stat icon={ClockMajor} count={statistics?.ScheduledCount} label="scheduled" />
      <Stat icon={StatusActiveMajor} count={statistics?.EndedCount} label="ended" />
    </InlineGrid>
  </Card>
);

const Stat = ({ icon, count, label }) => (
  <Link url="/campaigns" monochrome removeUnderline>
    <InlineStack gap="300" blockAlign="center" wrap={false}>
      <span><Icon source={icon} tone="subdued" /></span>
      <BlockStack>
        <Text as="span" variant="headingLg">{count ?? "-"}</Text>
        <Text as="span" tone="subdued">{label}</Text>
      </BlockStack>
    </InlineStack>
  </Link>
);

export default CampaignOverview;
